import { Area } from './area';
import { BullpenStatus } from './bullpen-status';
import { RigRampStatus } from './rig-ramp-status';
import { Scenario } from './scenario';
import { TargetFormation } from './target-formation';
import { WellStatus } from './well-status';
import { WellType } from './well-type';
import { Bitdata } from 'app/shared/data/bit-data';

export class ScenarioDrillGroupFilterCriteria {

  /* AREA RELATED */
  DevelopmentAreaIds?: number[];
  DevelopmentAreas?: Area[];

  LeaseAreaIds?: number[];
  LeaseAreas?: Area[];

  TargetFormationAreaIds?: number[];
  TargetFormationAreas?: Area[];

  TankBatteryAreaIds?: number[];
  TankBatteryAreas?: Area[];

  PioneerWaterManagementAreaIds?: number[];
  PioneerWaterManagementAreas?: Area[];

  SaltWaterDisposalFacilityAreaIds?: number[];
  SaltWaterDisposalFacilityAreas?: Area[];

  BullpenStatusIds?: number[];
  BullpenStatuses?: BullpenStatus[];
  DevTeamAreaIds?: number[];
  DevTeamAreas?: Area[];
  DirectReturnOnInvestmentCutoff?: number;
  DirectReturnOnInvestmentCutoffIsLessThan: boolean;
  DrillingAreaIds?: number[];
  //DrillingAreas?: DrillingArea[]; //may be added back in
  HasAllocationWell?: boolean;
  HasJointVentureWell?: boolean;
  HasManuallyIncluded?: boolean;
  HasObligationOverride?: boolean;
  ManuallySelectedDrillGroupIds: number[] = [];
  NetRevenueInterest?: number;
  NetRevenueInterestIsLessThan: boolean;
  RigRampStatusIds?: number[];
  RigRampStatuses?: RigRampStatus[];
  ScenarioId: number;
  Scenario?: Scenario;
  ScenarioStartDate: Date;
  ScenarioEndDate: Date;
  TargetFormationIds?: number[];
  TargetFormations?: TargetFormation[];
  WellStatusIds?: number[];
  WellStatuses?: WellStatus[];
  WellTypeIds?: number[];
  WellTypes?: WellType[];
  WorkingPercentInterest?: number;
  WorkingPercentInterestIsLessThan: boolean;

  constructor() {
    // AllocationWellStatuses: [],
    // EndOfHps: false,
    this.DevelopmentAreaIds = [];
    this.LeaseAreaIds = [];
    this.TargetFormationAreaIds = [];
    this.BullpenStatusIds = [];
    this.DevTeamAreaIds = [];
    this.DirectReturnOnInvestmentCutoff = 0;
    this.DirectReturnOnInvestmentCutoffIsLessThan = true;
    this.DrillingAreaIds = [];
    this.HasAllocationWell = Bitdata.YesNo[0].value;
    this.HasJointVentureWell = Bitdata.YesNo[0].value;
    this.HasManuallyIncluded = Bitdata.YesNo[0].value;
    this.HasObligationOverride = false;
    this.NetRevenueInterest = 0;
    this.NetRevenueInterestIsLessThan = true;
    this.PioneerWaterManagementAreaIds = [];
    this.RigRampStatusIds = [];
    this.SaltWaterDisposalFacilityAreaIds = [];
    this.ScenarioEndDate = new Date();
    this.ScenarioStartDate = new Date();
    this.ScenarioId = 0;
    this.TankBatteryAreaIds = [];
    this.TargetFormationIds = [];
    this.WellStatusIds = [];
    this.WellTypeIds = [];
    this.WorkingPercentInterest = 100.0;
    this.WorkingPercentInterestIsLessThan = true;
  }
}
